import React, { Component } from "react";

class EgpLanguageCols extends Component {
  handleChange = (event) => {
    const selectedLabel = event.target.value;
    const selectedItem = this.props.langList.find(
      (item) => item.label === selectedLabel
    );
    if (this.props.onChangeLanguage && selectedItem) {
      this.props.onChangeLanguage(selectedItem);
    }
  };

  render() {
    return (
      <select
        value={this.props.langName}
        onChange={this.handleChange}
        className={`egp-language-select ${this.props.classList?.select || ""}`}
      >
        {this.props.langList.map((item) => (
          <option key={item.id} value={item.label} className="select_item">
            {item.label}
          </option>
        ))}
      </select>
    );
  }
}

export default EgpLanguageCols;
